// libs
import React, { memo, useState, useCallback } from "react";

// components
import Header from "shared/components/Header/MobileHeader";
import AuthModalWrapper from "shared/components/AuthModal/AuthModalWrapper";

// provider
import MobileActionProvider from "shared/components/Header/MobileAction";
import MobileLayoutContext from "./MobileLayoutContext";

// styles
import { Container } from "./styles";

// defs
import { IHeaderOptions } from "shared/store/app/types";
interface IMobileHeaderProviderProps {
    children: React.ReactNode;
    className?: string;
    headerProps: IHeaderOptions;
    isHeaderVisible: boolean;
}

const DEFAULT_STYLES = {};

function MobileHeaderProvider({
    children,
    className,
    headerProps,
    isHeaderVisible,
}: IMobileHeaderProviderProps) {
    const [headerStyles, setHeaderStyles] = useState<React.CSSProperties>(DEFAULT_STYLES);
    const [HeaderContent, setHeaderContent] = useState<React.ReactNode | undefined>(undefined);
    const [HeaderActions, setHeaderActions] = useState<React.ReactNode | undefined>(undefined);

    const setCSS = useCallback((styles: React.CSSProperties) => setHeaderStyles(styles), []);
    const resetCSS = useCallback(() => setHeaderStyles(DEFAULT_STYLES), []);

    const { showDiscount, headerMerge } = headerProps;

    return (
        <Container
            allowPadding={isHeaderVisible && headerMerge === false}
            isDiscountVisible={showDiscount}
            className={className}
            style={headerStyles}
        >
            <AuthModalWrapper>
                <MobileActionProvider>
                    {isHeaderVisible && (
                        <Header
                            {...headerProps}
                            HeaderContent={HeaderContent}
                            MobileActions={HeaderActions}
                        />
                    )}
                    <MobileLayoutContext.Provider
                        value={{ setHeaderContent, setHeaderActions, setCSS, resetCSS }}
                    >
                        {children}
                    </MobileLayoutContext.Provider>
                </MobileActionProvider>
            </AuthModalWrapper>
        </Container>
    );
}

export default memo(MobileHeaderProvider);
